export default "__VITE_ASSET__1g1WVNKV__"